import api from "services/api";
import { getLeaveDateMap } from "common/calendar";

const PAGE_SIZE = 100;
const MAX_PAGES = 10;
const STATUSES = "PENDING,APPROVED";

const getMyLeaves = async () => {
	const applications = [];
	let page = 0;
	let last = false;

	while (!last && page < MAX_PAGES) {
		const response = await api.get.leaves.list({ page, size: PAGE_SIZE, statusListStr: STATUSES });

		applications.push(...(response?.content || []));
		last = response?.last ?? true;
		page += 1;
	}

	return getLeaveDateMap(applications);
};

export default getMyLeaves;
